import React, { ReactElement } from "react";
import { Loading } from "../../Loading";
import { Agency } from "../../messages/Agency";
import { OfficeId } from "../../messages/ObjectIds";
import { OfficeInfo } from "../../messages/Office";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { CALL_SVG } from "../../utils/svgs";
import { AppBottomSheet, AppBottomSheetProps } from "../Generic/AppBottomSheet";
import { AppCard, AppCardContent } from "../Generic/AppCard";
import { AppIcon } from "../Generic/AppIcon";
import { AppListItem } from "../Generic/AppList";
import { AppOverlay } from "../Generic/AppOverlay";
import { If } from "../Generic/If";
import { IsDefined } from "../Generic/IsDefined";
import { IsLoaded } from "../Generic/IsLoaded";

interface Props extends AppBottomSheetProps {
  isOpen: boolean;
  header: string;
  description: string;
  offices: OfficeInfo[];
  agency: Agency | undefined | Loading;
  onRequestClose: () => void;
}

export function CallOfficeSheet(props: Props): ReactElement {
  const officesWithPhones = props.offices.filter((office) => office.phoneNumber !== null);

  return (
    <AppOverlay>
      <AppBottomSheet {...props} className="CallOfficeSheet">
        <h2 className="CallOfficeSheet__header">{props.header}</h2>
        <p className="CallOfficeSheet__description">{props.description}</p>
        {officesWithPhones.map((office) => (
          <AppCard key={OfficeId.unwrap(office.id)}>
            <a href={`tel:${office.phoneNumber}`}>
              <AppCardContent>
                <AppListItem
                  leading={<AppIcon icon={CALL_SVG} fill="black" />}
                  title={`${translate(STRINGS.CONTACT)} ${office.name}`}
                />
              </AppCardContent>
            </a>
          </AppCard>
        ))}
        <If condition={officesWithPhones.length === 0}>
          <IsLoaded value={props.agency} placeholder={translate(STRINGS.LOADING)}>
            {(maybeAgency) => (
              <IsDefined value={maybeAgency}>
                {(agency) => (
                  <IsDefined value={agency.officePhone}>
                    {(agencyPhoneNumber) => (
                      <AppCard>
                        <a href={`tel:${agencyPhoneNumber}`}>
                          <AppCardContent>
                            <AppListItem
                              leading={<AppIcon icon={CALL_SVG} fill="black" />}
                              title={`${translate(STRINGS.CALL_AGENCY)}`}
                            />
                          </AppCardContent>
                        </a>
                      </AppCard>
                    )}
                  </IsDefined>
                )}
              </IsDefined>
            )}
          </IsLoaded>
        </If>
      </AppBottomSheet>
    </AppOverlay>
  );
}
